import React, { createContext, useContext } from 'react'

export const TOCContext = createContext()
export const TOCProvider = props => <TOCContext.Provider {...props} />

export const useTOCContext = () => useContext(TOCContext)
